import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoTableTitleContainer,
    convertUniversalDateToPersianDate,
    RaikoCustomSimpleChip,
    RaikoChipTypes, showServerErrorMessage, addNewRowToTable, RaikoDefaultDialogPage, DialogSize
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {OccasionalService} from "../../serverService/occasional/OccasionalService";
import ThumborHelper from "../../util/ThumborHelper";
import thumbnail from "../../assets/svg/thumbnail.svg"
import {useNavigate} from "react-router-dom";
import AddNewOccasionalBanner from "./occasionalBannerDetails/AddNewOccasionalBanner";

export default function OccasionalBanner() {

    let page = 0
    const size = 15

    const service = new OccasionalService()

    const [isLoading, setIsLoading] = useState(false)
    const [occasionalBannerData, setOccasionalBannerData] = useState([])
    const [pageCount, setPageCount] = useState(0)
    const [numberOfItems, setNumberOfItems] = useState(0);
    const [openAddNewOccasionalBannerModal, setOpenAddNewOccasionalBannerModal] = useState(false);


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getDataFromServer()
        }
    }, []);


    function preparationOccasionalBannerRow(
        id,
        number,
        banner,
        title,
        slug,
        startDate,
        endDate,
        published,
        createdBy,
        createdAt
    ) {
        return {
            id,
            number,
            banner,
            title,
            slug,
            startDate: startDate ? convertUniversalDateToPersianDate(startDate) : "---",
            endDate: endDate ? convertUniversalDateToPersianDate(endDate) : '---',
            published: published ?
                <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
            createdBy,
            createdAt: convertUniversalDateToPersianDate(createdAt),
        }
    }

    function getDataFromServer() {
        setIsLoading(true)
        service.getBannerItems(page, size)
            .then(response => {

                setNumberOfItems(response.numberOfItems)
                setPageCount(response.totalPage)
                setOccasionalBannerData([])

                response.data.map((item, index) => {
                    setOccasionalBannerData(prev => [
                        ...prev,
                        preparationOccasionalBannerRow(
                            item.id,
                            (page * size) + index + 1,
                            item.banner && item.banner.downloadUrl ?
                                <img
                                    src={new
                                    ThumborHelper.Builder(item.banner.downloadUrl)
                                        .setImageCompressSize(50, 50)
                                        .changeQuality(10)
                                        .convertWebp()
                                        .build()
                                    }
                                    className={css`
                                        width: 50px;
                                        height: 50px;
                                        aspect-ratio: 3/2;
                                        border-radius: 8px;
                                        background: var(--header-border-bottom-color)`
                                    }
                                    alt=""/>
                                : <img
                                    src={thumbnail}
                                    className={css`
                                        border-radius: 8px;
                                        width: 50px;
                                        height: 50px;
                                        aspect-ratio: 3/2;
                                        object-fit: cover;`
                                    }
                                    alt=""/>

                            ,
                            item.title,
                            item.slug,
                            item.startDate,
                            item.endDate,
                            item.published,
                        )
                    ])
                })

            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setIsLoading(false)
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    const navigate = useNavigate()

    function showOccasionalBannerDetails(id) {
        let _title = ""
        occasionalBannerData.map((item) => {
            if (item.id === id)
                _title = item.title
        })


        navigate(RouteHelper.OccasionalBannerDetail.globalUrl.replace(":id", id),
            {state: {title: _title}, replace: false}
        )
    }
    function handleOpenAddOccasionalNew() {
        setOpenAddNewOccasionalBannerModal(true)
    }
    function handleCloseAddNewBannerDialog() {
        setOpenAddNewOccasionalBannerModal(false)
    }

    function handleAddNewItemToList(item) {
        handleCloseAddNewBannerDialog()
        const _items = addNewRowToTable(preparationOccasionalBannerRow(
            item.id,
            1,
            "",
            item.title,
            item.slug,
            "",
            "",
            item.published,
        ), occasionalBannerData)
        setOccasionalBannerData(_items);
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.OccasionalBanner.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseAddNewBannerDialog}
                open={openAddNewOccasionalBannerModal}
                dialogSize={DialogSize.WRAP_CONTENT}
                >
                <AddNewOccasionalBanner handleAddNewItem={handleAddNewItemToList} handleCloseDialog={handleCloseAddNewBannerDialog}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(RouteHelper.Android.name, ""),
                        raikoBreadCrumbItemGenerator(RouteHelper.OccasionalBanner.name, ""),
                    ]}/>
                </RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"بنر مناسبتی"}
                            amount={numberOfItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenAddOccasionalNew}
                        />
                        <RaikoCustomTable
                            isLoading={isLoading}
                            data={occasionalBannerData}
                            header={occasionalBannerHeader}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={showOccasionalBannerDetails}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>
        </>
    )
}

const occasionalBannerHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "banner",
        label: "عکس"
    },
    {
        id: "title",
        label: "عنوان"
    },
    {
        id: "slug",
        label: "slug",
    },
    {
        id: "startDate",
        label: "تاریخ شروع"
    },
    {
        id: "endDate",
        label: "تاریخ پایان"
    },
    {
        id: "published",
        label: "وضعیت انتشار"
    },
]